export default __webpack_public_path__ + "static/media/heart.977a329b.webp";